import { observable, action } from "mobx";
import { ELeftMenuTab } from "common/enums";

class Store {
  @observable leftTab: ELeftMenuTab = ELeftMenuTab.CLOSED; // ativa o content.tsx
  @observable showSnack: string = "";
  @observable snackSecondMessage: string = "";
  @observable canLoadingOnContent = false;

  @action
  resetStore() {
    this.leftTab = ELeftMenuTab.CLOSED;
    this.showSnack = "";
    this.snackSecondMessage = "";
    this.canLoadingOnContent = false;
  }

  @action
  showSnackMessage(message: string, secondMessage: string = "") {
    this.showSnack = message;
    this.snackSecondMessage = secondMessage;
  }

  @action
  enableLoadingOnContent(enabled: boolean) {
    ProjectStore.canLoadingOnContent = enabled;
  }
}

let ProjectStore = new Store();

export { ProjectStore };



// WEBPACK FOOTER //
// ./src/modules/project/ProjectStore.ts